mutation RequestProfilePictureUploadUrl(
  $contentType: String!
  $contentLength: Int!
) {
  upload: StreamToolsRequestProfilePictureUploadUrl(
    contentType: $contentType
    contentLength: $contentLength
  ) {
    uploadUrl
    publicUrl
    expiresAt
    s3Key
  }
}
